// Partials
// import Hero from 'partials/hero';
// import Team from 'partials/team';
// import Offers from 'partials/offers';
import Video from 'partials/video';

// Home Class
class Home {

  /**
   * Constructor:
   * Template constructor called in `manager.js` file.
   *
   * @constructor
   * @param {Object} options - Template class options
   */
  constructor({ el }) {
    // Root
    this.$root = el;

    // Partials
    this.$hero = this.$root.querySelector('[type="hero"]');
    // this.$team = this.$root.querySelector('[type="team"]');
    this.$offers = this.$root.querySelector('[type="offers"]');
    this.$video = this.$root.querySelectorAll('.js-video-container');

    // Partials Class
    // this.Hero = new Hero({ el: this.$hero });
    // this.Team = new Team({ el: this.$team });
    // this.Offers = new Offers({ el: this.$offers });
    this.Video = new Video({ el: this.$video});
  }
}

export default Home;
